import React from 'react'
import Toolbar from './toolbar'
import Drawer from './drawer'
import { connect } from 'react-redux'
import { logOutAction } from '../../../actions/usersActions'
import { cleanStatusAction } from '../../../actions/appActions'
import routes from '../../router/routes'

class Component extends React.Component {
    state = {
        toggleDrawerOpened: false,
    }

    toggleDrawer = (open) => () => {
        this.setState({ toggleDrawerOpened: open })
    }

    handleLogOut = (history) => {
        this.props.logOutAction(history)
        this.props.cleanStatusAction()
    }

    getValidLinks = (routes) => {
        if (!this.props.userStore.authenticated) {
            return routes.filter((x) => x.requireAuth === false)
        }
        return routes
    }

    render() {
        const drawerLinks = this.getValidLinks([routes.orders, routes.config])
        return (
            <section className={'templateWrapper'} >
            { this.props.userStore.authenticated ?
                <>
                    <section className={'templateWrapperToolbar'} style={{marginBottom:'50px'}}>
                        <Toolbar
                            toggleDrawer={
                                !drawerLinks.length ? null : this.toggleDrawer
                            }
                            authenticated={this.props.userStore.authenticated}
                            handleLogOut={this.handleLogOut}
                            platform={this.props.appStore.platform}
                            shop={this.props.appStore.shopAlias}
                        />
                    </section>
                    <section className={'templateWrapperDrawer'}>
                        <Drawer
                            toggleDrawer={this.toggleDrawer}
                            toggleDrawerOpened={this.state.toggleDrawerOpened}
                            links={drawerLinks}
                        />
                    </section>
                </>
             : null
             }
                <section className={'templateWrapperContent'}>
                    <section className={'templateWrapperContent-overflow'}>
                        {this.props.children}
                    </section>
                </section>
            </section>
        )
    }
}

const mapStateToProps = (store) => ({
    userStore: store.user,
    appStore: store.app,
})
const mapDispatchToProps = { logOutAction, cleanStatusAction }
export default connect(mapStateToProps, mapDispatchToProps)(Component)
